module.exports = __webpack_public_path__ + "img/picture_03_portada.3f4a4af7.png";